"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Handshake, PhoneCall, ArrowUpLeft, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StartYourPartnershipWithUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="234156" id="inscríbete" className="dark bg-background text-foreground relative py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-[120px] opacity-50 mix-blend-screen"></div>
        <div className="absolute bottom-0 right-1/4 w-[30rem] h-[30rem] bg-primary/5 rounded-full blur-[150px] opacity-50"></div>
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/academy_texture_overlay.png')] opacity-[0.03] mix-blend-overlay"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-5xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Card className="bg-card/40 backdrop-blur-xl border-border/50 shadow-2xl overflow-hidden relative rounded-3xl">
            {}
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-transparent pointer-events-none"></div>
            
            <CardContent className="p-10 md:p-16 flex flex-col items-center text-center relative z-10">
              <div className="w-20 h-20 rounded-2xl bg-primary/10 flex items-center justify-center mb-8 border border-primary/20 shadow-inner">
                <Handshake className="w-10 h-10 text-primary" />
              </div>

              <h2 className="font-default text-3xl md:text-5xl font-bold mb-6 tracking-tighter text-foreground">Abierta&nbsp; inscripción&nbsp; curso 2026 / 2027</h2>
              
              <p className="font-default text-lg md:text-xl text-muted-foreground max-w-3xl mb-10 leading-relaxed">&nbsp;Asegúrate hoy mismo una plaza en tu próximo curso.</p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 w-full max-w-3xl mb-12 text-left">
                
                
                
              </div>

              <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
                <Button asChild size="lg" className="h-14 px-8 text-lg rounded-xl bg-primary text-primary-foreground shadow-primary/25 shadow-lg hover:shadow-primary/40 transition-all">
                  <Link to="/ContactPage">
                    <PhoneCall className="w-5 h-5 mr-2" />
                    Inscríbete Ahora
                  </Link>
                </Button>
                <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg rounded-xl border-border/50 hover:bg-accent/50 transition-all">
                  <Link to="/CoursesPage">
                    Ver Cursos
                    <ArrowUpLeft className="w-5 h-5 ml-2" />
                  </Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}